import React, { useState, useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import axios from 'axios';
import { safeDccContinuation, withDccContinuation } from './authContinuation';

export default function VerifyEmail() {
  const [searchParams]              = useSearchParams();
  const [status, setStatus]         = useState('verifying'); // verifying | success | error
  const [message, setMessage]       = useState('');
  const navigate                    = useNavigate();
  const token                       = searchParams.get('token') || '';
  const redirect                    = searchParams.get('redirect');
  const dccContinuation             = safeDccContinuation(redirect);

  useEffect(() => {
    if (!token) {
      setStatus('error');
      setMessage('No verification token found. Please check your email link.');
      return;
    }

    axios.post('/v1/auth/verify-email', { token }, { withCredentials: true })
      .then(() => {
        setStatus('success');
        setMessage('Your email has been verified. You can now sign in.');
      })
      .catch(err => {
        setStatus('error');
        setMessage(
          err.response?.data?.error ||
          'This verification link is invalid or has already been used.'
        );
      });
  }, [token]);

  return (
    <div style={styles.page}>
      <div style={styles.card}>
        <div style={styles.logo}>Visinvoke</div>

        {status === 'verifying' && (
          <>
            <h2 style={styles.title}>Verifying your email...</h2>
            <p style={styles.body}>Please wait a moment.</p>
          </>
        )}

        {status === 'success' && (
          <>
            <div style={styles.iconSuccess}>✓</div>
            <h2 style={styles.title}>Email Verified</h2>
            <p style={styles.body}>{message}</p>
            <button style={styles.btn} onClick={() => {
              if (dccContinuation) { window.location.assign(dccContinuation); return; }
              navigate('/login');
            }}>
              Sign In
            </button>
          </>
        )}

        {status === 'error' && (
          <>
            <div style={styles.iconError}>✕</div>
            <h2 style={styles.title}>Verification Failed</h2>
            <div style={styles.error}>{message}</div>
            <button style={styles.btn} onClick={() => navigate(withDccContinuation('/login', dccContinuation))}>
              Back to Sign In
            </button>
          </>
        )}
      </div>
    </div>
  );
}

const styles = {
  page:        { minHeight: '100vh', background: 'linear-gradient(135deg, #334155, #881337)', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 24 },
  card:        { background: '#fff', borderRadius: 12, padding: '40px 36px', width: '100%', maxWidth: 420, boxShadow: '0 20px 60px rgba(0,0,0,0.3)', textAlign: 'center' },
  logo:        { fontWeight: 900, fontSize: 22, color: '#8b5cf6', marginBottom: 8 },
  title:       { margin: '0 0 16px', fontSize: 20, fontWeight: 700, color: '#1a1a1a' },
  body:        { fontSize: 14, color: '#555', lineHeight: 1.6, margin: '0 0 24px' },
  error:       { background: '#fee2e2', border: '1px solid #fecaca', color: '#991b1b', padding: '10px 14px', borderRadius: 8, marginBottom: 20, fontSize: 14, textAlign: 'left' },
  iconSuccess: { fontSize: 40, color: '#16a34a', marginBottom: 12 },
  iconError:   { fontSize: 40, color: '#dc2626', marginBottom: 12 },
  btn:         { width: '100%', background: 'linear-gradient(135deg, #8b5cf6, #a855f7)', color: '#fff', border: 'none', borderRadius: 8, padding: '12px 0', fontWeight: 700, fontSize: 15, cursor: 'pointer', marginTop: 8 },
};
